import React from 'react';

const Context = React.createContext({
    resumo: {},
    setResumo: () => { },
    modal: false,
    setModal: () => { },
    activePage: false,
    setActivePage: () => { }
});

export default Context;